import APICall from "../APICall";
import EndPoints from "../APICall/EndPoints";

export const getApplicationLink = async () => {
  let response = await APICall("get", EndPoints.getApplicationLink);
  return response.data.data?.[0];
};
